import api from "../api/apiClient";

const nodeService = {
    // New function for file content API
    fetchDocumentContent: async (filePath) => {
        try {
            const response = await api.post('/FileContent', { path: filePath });
            if (response.status !== 200) {
                throw new Error('Failed to fetch document content');
            }
            return response.data;
        } catch (error) {
            console.error('Error in fetchDocumentContent:', error);
            throw error;
        }
    },

    // New function for fetching child nodes by node ID and user ID
    fetchChildNodes: async (nodeId, userId = 1) => {
        try {
            const response = await api.post(`/graph/allchild/${userId}/`, { nodeid: nodeId });
            if (response.status !== 200) {
                throw new Error('Failed to fetch child nodes');
            }
            return response.data;
        } catch (error) {
            console.error('Error in fetchChildNodes:', error);
            throw error;
        }
    },

    fetchNodeData: async (oid) => {
        try {
            const response = await api.get(`/export-data-model/%22${oid}%22/`);
            if (response.status !== 200) {
                throw new Error('Failed to fetch node data');
            }
            return response.data.success; // Return only the 'success' array
        } catch (error) {
            console.error('Error in fetchNodeData:', error);
            throw error;
        }
    },

    fetchInstances: async () => {
        try {
            const response = await api.get('/instances/');
            if (response.status !== 200) {
                throw new Error('Failed to fetch instances');
            }
            return response.data;
        } catch (error) {
            console.error('Error in fetchInstances:', error);
            throw error;
        }
    },

   updateNodeInstance : async (nodeId, newProps) => {
        try {
          const response = await api.post(`/instances/${nodeId}/`, newProps, {
            headers: {
              'Content-Type': 'application/json',
            },
          });
          return response.data;
        } catch (error) {
          console.error('Error updating node instance:', error);
          throw error;
        }
      },
      
     deleteNodeInstance : async (id) => {
        try {
          const response = await api.delete(`/instances/${id}/`, {
            headers: {
              'Content-Type': 'application/json',
            },
          });
          return response.data;
        } catch (error) {
          console.error('Error deleting node instance:', error);
          throw error;
        }
      },
      
     createRelationInstance : async (className, fromId, toId, props = {}) => {
        try {
          const response = await api.post(`/relations/`, {
            relation_name: className,
            src_id: fromId,
            dst_id: toId,
            rel_attrs: props,
          }, {
            headers: {
              'Content-Type': 'application/json',
            },
          });
      
          // If you need to perform additional actions after successful creation,
          // you can do so here or return the response and handle it in the component
          return response.data;
        } catch (error) {
          console.error('Error creating relation instance:', error);
          throw error;
        }
      },
      
      // If you need the loadChildGraphByNode function, you can add it here as well
     loadChildGraphByNode : async (nodeId) => {
        // Implement this function based on your specific requirements
      }
};

export default nodeService;
